import { render } from "./IndicatorBuilder.vue?vue&type=template&id=90a28706&scoped=true"
import script from "./IndicatorBuilder.vue?vue&type=script&lang=js"
export * from "./IndicatorBuilder.vue?vue&type=script&lang=js"

import "./IndicatorBuilder.vue?vue&type=style&index=0&id=90a28706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a28706"]])

export default __exports__